function headerLocationDropdown() {
    const blocks = document.querySelectorAll('[data-location-dropdown-block]');

    blocks.forEach(block => {
        const btn = block.querySelector('[data-location-dropdown-main-btn]');
        const dropdown = block.querySelector('.header_location__dropdown');
        const btnClose = block.querySelector('[data-btn-close]');
        const clickChangeBtns = block.querySelectorAll('[data-click-change]');
        const clickChangeText = block.querySelector('[data-change-text=""]');

        btn.addEventListener('click', (el) => {
            el.stopPropagation;
            block.classList.toggle('is-open');
        })

        btnClose.addEventListener('click', _ => {
            block.classList.remove('is-open');
        })

        clickChangeBtns.forEach(btn => {
            btn.addEventListener('click', _ => {
                clickChangeText.textContent = btn.textContent;
                block.classList.remove('is-open');
            })
        })

    })

    document.addEventListener('click', e => {
        if (e.target.closest('[data-dropdown-block]') || e.target.closest('[data-location-dropdown-block]')) return;
        blocks.forEach(block => {
            block.classList.remove('is-open')
        })
    })

}

export default headerLocationDropdown;
